import { findTranslate } from 'app/utils/translate';
import { GRAMMAR } from 'app/constants/categories';
import { useTranslation } from 'next-i18next';
import { Category } from 'types/category';
import { useRouter } from "next/router";
import { Blog } from 'types/blog';
import { Test } from 'types/test';
import Link from 'next/link';

import { faLink } from "@fortawesome/free-solid-svg-icons";
import FontAwesomeIcon from "app/components/layouts/Icons/FontAwesome";

const Links = ({ game }) => {
  let indexLink = 1;
  const { t } = useTranslation();
  const router = useRouter();
  const { blogs, categories, tests } = game;

  const getIndex = () => {
    indexLink += 1;
    return indexLink;
  }

  return (
    <div className="links">
      {categories.length > 0 &&
        <div className="form-group">
          <b className='title-category'>
            {getIndex()}. {t('navigations.vocabulary')}
          </b>
          <div>
            {
              categories.map((category: Category) => {
                return <Link
                  key={category.slug}
                  className='text-info text-size-md d-block py-1 uppercase-first'
                  href={`/vocabularies/topics/${category.slug}`}
                >
                  <FontAwesomeIcon className="text-warning mr-2" icon={faLink} />
                  {category?.title[router?.locale ?? 'vi']}
                </Link>
              })
            }
          </div>
        </div>
      }

      {blogs.length > 0 &&
        <div className="form-group">
          <b className='title-category'>
            {getIndex()}. {t('routes.blog_des')}
          </b>
          <div>
            {
              blogs.map((blog: Blog) => {
                return <Link
                  key={blog.id}
                  className='text-info text-size-md d-block py-1 uppercase-first'
                  href={`/${blog.category_id == GRAMMAR ? 'grammar' : 'news'}/${blog[`slug_${router?.locale}`]}`}
                >
                  <FontAwesomeIcon className="text-warning text-size-sm mr-2" icon={faLink} />
                  {findTranslate(blog?.translates, 'title', router?.locale)}
                </Link>
              })
            }
          </div>
        </div>
      }

      {tests.length > 0 &&
        <div className="form-group">
          <b className='title-category'>
            {getIndex()}. {t('tests.grammar_test')}
          </b>
          <div>
            {
              tests.map((test: Test) => {
                return <Link
                  key={test.id}
                  className='text-info text-size-md d-block py-1 uppercase-first'
                  href={`/tests/detail/${test.slug}`}
                >
                  <FontAwesomeIcon className="text-warning text-size-sm mr-2" icon={faLink} />
                  {test.title[router?.locale || 'vi']}
                </Link>
              })
            }
          </div>
        </div>
      }

      <style jsx>{`
        .title-category {
          font-size: 18pt;
          color: #169179;
        }
      `}</style>
    </div>
  )
}

export default Links;
